import type { AnyAction } from 'redux';

import type { TwilioTokenRegion } from '../types';

export type TwilioActionHandler = (action: AnyAction) => void;

export type AsyncTwilioCommandOptions<TResult, TError = unknown> = {
  action: AnyAction;
  run: () => Promise<TResult>;
  onSucceeded: (result: TResult) => void;
  onFailed: (error: TError) => void;
  captureException?: boolean;
};

export type RegionAwareTwilioCommandOptions<
  TResult,
  TError = unknown,
> = AsyncTwilioCommandOptions<TResult, TError> & {
  resolveRegion: () => Promise<TwilioTokenRegion | undefined>;
  onMissingRegion: () => void;
  beforeRun?: () => void;
};

export const abortTwilioCommandSymbol = Symbol('ABORT_TWILIO_COMMAND');
